export default __webpack_public_path__ + "static/media/DailyIcon.47ff1826.svg";